// extracted by mini-css-extract-plugin
module.exports = {"content":"UiButton_content__bSvBc"};